import React from "react";
import clsx from "clsx";

import { useGetLocationData } from "~/hooks/locationData";
import s from "./TableRow.less";
import Galka from "~/components/Icons/svg/galka";
import { getShortDate } from "~/libs/getFormatDate";
import { openStaffEmployeeWindow } from "~/shared/lib/createURL";
import { getStaffCellToneClass } from "./staffCellCompare";

interface IProps {
  options: string[];
  withChbx?: boolean;
  item;
}

const StaffTableRow: React.FC<IProps> = ({ options = [], item = {} }) => {
  const { filterBy, filterItems, period } = useGetLocationData() as any;

  const goToEmployee = (position, Positions) => () => {
    const ids = Positions.map((p) => p.instanceId);

    openStaffEmployeeWindow({
      position,
      positionIds: ids,
      filterBy: filterBy.value,
      period: getShortDate(period),
      filterItems: filterItems || [],
    });
  };

  return (
    <>
      <tr className={s.row_tr}>
        {options?.map((optionName) => (
          <td
            className={clsx(getStaffCellToneClass(item, optionName))}
            key={optionName}
            data-option_name={optionName}
          >
            <div
              onClick={
                optionName === "position"
                  ? goToEmployee(item.position, item.Positions)
                  : () => {}
              }
              className={clsx({
                [s.hover]: optionName === "position",
              })}
            >
              {optionName === "kpi" && !!item.kpi && <Galka />}
              <span className={s.cont}>{item[optionName]}</span>
            </div>
          </td>
        ))}
      </tr>
    </>
  );
};
export default StaffTableRow;
